var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.url)?_c('img',{staticClass:"media-gallery-image",style:(_setup.previewStyle),attrs:{"src":_setup.url,"draggable":"false"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }